<div class="helpia-modal-root">

  <!-- ═══════════════ HEADER GLASSMORPHISM (ANTI-NOTCH) ═══════════════ -->
  <div class="helpia-header">
    <div class="header-backdrop"></div>
    <div class="header-content">
      <button type="button" class="back-btn" (click)="cerrar()" aria-label="Cerrar">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>

      <div class="helpia-avatar-wrap">
        <div class="helpia-avatar">
          <ion-icon name="sparkles"></ion-icon>
        </div>
        <span class="online-dot"></span>
      </div>

      <div class="header-text">
        <div class="title-row">
          <h1 class="header-title">PG IA</h1>
          <span class="ai-badge">Gemini</span>
        </div>
        <span class="header-subtitle">Asistente Inteligente • {{ moduloContexto }}</span>
      </div>

      <button type="button" class="close-icon-btn" (click)="cerrar()" aria-label="Cerrar modal">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
  </div>

  <!-- ═══════════════ ÁREA DE CONVERSACIÓN ═══════════════ -->
  <div class="helpia-chat-area" #chatScroll>

    <!-- Atajos rápidos iniciales (Quick Prompts) -->
    <div class="quick-prompts-section" *ngIf="messages.length <= 1">
      <span class="qp-title">Consultas sugeridas:</span>
      <div class="qp-chips-grid">
        <button type="button" class="qp-chip" *ngFor="let prompt of quickPrompts" (click)="seleccionarPrompt(prompt)" [disabled]="loading">
          <ion-icon name="bulb-outline"></ion-icon>
          <span>{{ prompt }}</span>
        </button>
      </div>
    </div>

    <!-- Lista de Mensajes -->
    <div class="messages-list">
      <div *ngFor="let msg of messages; trackBy: trackByMsgId"
           class="chat-bubble-wrap"
           [ngClass]="msg.sender === 'user' ? 'bubble-user' : 'bubble-ia'">

        <!-- Avatar para la IA -->
        <div class="msg-avatar" *ngIf="msg.sender === 'ia'">
          <ion-icon name="sparkles"></ion-icon>
        </div>

        <div class="bubble-content">
          <div class="bubble-header" *ngIf="msg.sender === 'ia'">
            <span class="bubble-sender-name">PG IA</span>
            <button type="button" class="copy-btn" (click)="copiarTexto(msg.text)" title="Copiar respuesta">
              <ion-icon name="copy-outline"></ion-icon>
            </button>
          </div>

          <p class="bubble-text">{{ msg.text }}</p>

          <span class="bubble-time">
            {{ msg.timestamp | date:'shortTime' }}
          </span>
        </div>
      </div>

      <!-- Burbuja de carga / pensando -->
      <div class="chat-bubble-wrap bubble-ia" *ngIf="loading">
        <div class="msg-avatar thinking">
          <ion-icon name="sparkles"></ion-icon>
        </div>
        <div class="bubble-content thinking-bubble">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span class="thinking-text">{{ statusMessage || 'Procesando consulta...' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════ FOOTER INPUT GLASSMORPHISM ═══════════════ -->
  <div class="helpia-footer">
    <div class="input-container-glass">
      <textarea
        class="custom-chat-input"
        [(ngModel)]="queryText"
        placeholder="Escribe tu consulta para PG IA..."
        rows="1"
        (keydown.enter)="$event.preventDefault(); enviarConsulta()"
        [disabled]="loading"></textarea>

      <button type="button"
              class="send-btn"
              (click)="enviarConsulta()"
              [disabled]="loading || !queryText.trim()"
              aria-label="Enviar">
        <ion-icon name="send"></ion-icon>
      </button>
    </div>
  </div>

</div>
